import DashboardLayout from "@layouts/DashboardLayout";
import CheckSecurityClearancePage from "@pages/check-security-clearance/CheckSecurityClearancePage";
import NotificationsPage from "@pages/notifications/NotificationsPage";
import UnautorizedPage from "@pages/UnautorizedPage";
import VendorLicenseRequestConfirmationPage from "@pages/vendor-license-request/VendorLicenseRequestConfirmationPage";
import VendorLicenseRequestPage from "@pages/vendor-license-request/VendorLicenseRequestPage";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { paths } from "@utils/navigation";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LoggedOut from "../pages/LoggedOut.tsx";
import { getBayHireRoutes } from "./config/bayHireRoutes";
import { getDeficienciesRoute } from "./config/deficienciesRoutes.tsx";
import { getDrybulkCargoOperationsRoutes } from "./config/drybulkCargoOperationsRoutes";
import { getGatepassRoutes } from "./config/gatepassRoutes";
import {
  getAccountsRoutes,
  getLicensesRoutes,
  getPortOperatorLicensesRoutes,
} from "./config/licensesRoutes";
import { getMovementServicesRoutes } from "./config/movementServicesRoutes.tsx";
import { getPortSecurityRoutes } from "./config/portSecurityRoutes";
import { getPortServicesRoutes } from "./config/portServicesRoutes";
import { getSettingsRoutes } from "./config/settingsRoutes";
import { getTerminalServicesRoutes } from "./config/terminalServicesRoutes";
import { getVesselCallRoutes } from "./config/vesselCallRoutes";
import { getVesselManagementRoutes } from "./config/vesselManagementRoutes";
import { getVesselNominationRoutes } from "./config/vesselNominationRoutes.tsx";
import { renderRoute } from "./renderRoute";

const AppRoutes = () => {
  const redirectPath = useAuthStore.getState().redirectPath;
  const location = useLocation();

  const routes = [
    getDeficienciesRoute(),
    getLicensesRoutes(),
    getAccountsRoutes(),
    getPortOperatorLicensesRoutes(),
    getVesselCallRoutes(),
    getVesselNominationRoutes(),
    getVesselManagementRoutes(),
    getPortSecurityRoutes(),
    getGatepassRoutes(),
    getBayHireRoutes(),
    getDrybulkCargoOperationsRoutes(),
    getSettingsRoutes(),
    getTerminalServicesRoutes(),
    getPortServicesRoutes(),
    getMovementServicesRoutes(),
  ];

  return (
    <Routes location={location}>
      <Route path="/logged-out" element={<LoggedOut key={location.key} />} />
      <Route path={paths.vendorLicenseRequest} element={<VendorLicenseRequestPage />} />
      <Route
        path={paths.vendorLicenseRequestConfirmation}
        element={<VendorLicenseRequestConfirmationPage />}
      />
      <Route path={paths.checkSecurityClearance} element={<CheckSecurityClearancePage />} />
      <Route path={paths.index} element={<DashboardLayout />}>
        <Route path={paths.unauthorized} element={<UnautorizedPage />} />
        <Route index element={<Navigate to={redirectPath} replace />} />
        <Route path={paths.notifications} element={<NotificationsPage />} />
        {routes.map((r) => renderRoute(r))}
      </Route>
    </Routes>
  );
};

export default AppRoutes;
